import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-testid="header">
      <div className="max-w-7xl mx-auto px-4 py-3 sm:py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <img
            src="/giri-logo.png"
            alt="GiriChat"
            className="w-8 h-8 sm:w-9 sm:h-9 object-contain rounded-lg"
          />
          <span className="text-lg sm:text-xl font-semibold text-gray-900">GiriChat</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          <button onClick={() => scrollToSection('features')} className="text-sm text-gray-700 hover:text-gray-900 transition-colors">Features</button>
          <button onClick={() => scrollToSection('pricing')} className="text-sm text-gray-700 hover:text-gray-900 transition-colors">Pricing</button>
          <Link to="/about" className="text-sm text-gray-700 hover:text-gray-900 transition-colors">About</Link>
          <button onClick={() => scrollToSection('testimonials')} className="text-sm text-gray-700 hover:text-gray-900 transition-colors">Testimonials</button>
          <button onClick={() => scrollToSection('faq')} className="text-sm text-gray-700 hover:text-gray-900 transition-colors">FAQ</button>
        </nav>

        <div className="flex items-center gap-2 sm:gap-4">
          <Button variant="ghost" className="hidden sm:inline-flex text-sm px-3" asChild>
            <Link to="/login" data-testid="signin-btn">Sign In</Link>
          </Button>
          <Button className="bg-[#00D95F] hover:bg-[#00C054] text-white text-xs sm:text-sm px-3 sm:px-4" asChild>
            <Link to="/signup" data-testid="get-started-btn">
              <span className="hidden xs:inline">Get Started</span>
              <span className="xs:hidden">Start</span>
            </Link>
          </Button>
          <button 
            className="lg:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-5 h-5 sm:w-6 sm:h-6" /> : <Menu className="w-5 h-5 sm:w-6 sm:h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 py-4 px-4 shadow-lg">
          <nav className="flex flex-col gap-1">
            <button onClick={() => scrollToSection('features')} className="text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-50 text-left py-3 px-3 rounded-lg transition-colors">Features</button>
            <button onClick={() => scrollToSection('pricing')} className="text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-50 text-left py-3 px-3 rounded-lg transition-colors">Pricing</button>
            <Link to="/about" className="text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-50 py-3 px-3 rounded-lg transition-colors" onClick={() => setMobileMenuOpen(false)}>About</Link>
            <button onClick={() => scrollToSection('testimonials')} className="text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-50 text-left py-3 px-3 rounded-lg transition-colors">Testimonials</button>
            <button onClick={() => scrollToSection('faq')} className="text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-50 text-left py-3 px-3 rounded-lg transition-colors">FAQ</button>
            <div className="border-t border-gray-200 mt-2 pt-2">
              <Link to="/login" className="text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-50 block py-3 px-3 rounded-lg transition-colors" onClick={() => setMobileMenuOpen(false)}>Sign In</Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
